import { HandHoldingDollarSolid } from '@allocab/allocab-icons';

import { formatTimeScopeToInput } from './utils';
import { Spinner } from '../../components/Spinner';
import { TimeScope, TimeScopeMode } from '../../components/time-scope-picker/types';
import { useFetchNetGains } from '../../hooks/useFetchNetGains';
import { t } from '../../services/translation/translation';
import { formatPrice } from '../../utils/price';

type Props = {
  scope: TimeScope;
  mode: TimeScopeMode;
  paymentStatus?: 'PENDING' | 'PAID';
};

export const NetGainsWidget = ({ scope, mode, paymentStatus }: Props) => {
  const { data, isLoading } = useFetchNetGains({
    ...formatTimeScopeToInput(scope, mode),
    paymentStatus,
  });

  return (
    <div className="flex flex-col  overflow-hidden relative lg:inline-flex lg:flex-row">
      <div className="flex flex-col items-center p-3 rounded-t-lg  border dark:border-b-0 border-gray-300 dark:border-gray-700 lg:rounded-tr-none lg:rounded-l-lg dark:lg:border-r-0 dark:lg:border-b">
        <div className="text-2xl">{data?.netGain.amount != null ? formatPrice(data.netGain.amount) : '--€'}</div>
        <div className="text-sm opacity-50 font-normal flex items-center gap-1">
          <p>
            {t('common.of-which-x-onboard', {
              price: data?.netGain.amountPaidOnBoard != null ? formatPrice(data.netGain.amountPaidOnBoard) : '--€',
            })}
          </p>
          <HandHoldingDollarSolid width={12} height={12} className="fill-white" />
        </div>
      </div>
      <div className="flex flex-wrap rounded-b-lg border border-t-0 dark:border-0 border-gray-300 dark:border-gray-900 bg-gray-50 dark:bg-gray-700 lg:rounded-bl-none lg:rounded-r-lg lg:border-l-0 lg:border-t ">
        <div className="flex-1 lg:flex-initial flex items-center flex-col p-3 gap-[2px] justify-center">
          <p className="text-xs opacity-50">{t('common.trips')}</p>
          <p className="">
            {data?.tripDetails.total.amount != null ? formatPrice(data.tripDetails.total.amount) : '--€'}
          </p>
        </div>
        {data?.packageDetails.total.amount != null && data.packageDetails.total.amount !== 0 ? (
          <div className="flex-1 lg:flex-initial flex items-center flex-col p-3 text-sm gap-[2px] justify-center">
            <p className="text-xs opacity-50">{t('common.packages')}</p>
            <p className="">{formatPrice(data.packageDetails.total.amount)}</p>
          </div>
        ) : null}
        {data?.penaltyDetails.total.amount != null && data.penaltyDetails.total.amount !== 0 ? (
          <div className="flex-1 lg:flex-initial flex items-center flex-col p-3 text-sm gap-[2px] justify-center">
            <p className="text-xs opacity-50">{t('common.penalties')}</p>
            <p className="text-red-600">-{formatPrice(data.penaltyDetails.total.amount)}</p>
          </div>
        ) : null}
        {data?.vaoCarDetails.total.amount != null && data.vaoCarDetails.total.amount !== 0 ? (
          <div className="flex-1 lg:flex-initial flex items-center flex-col p-3 text-sm gap-[2px] justify-center shrink-0">
            <p className="text-xs opacity-50">{t('common.vao-car-rental')}</p>
            <p className="text-red-600">-{formatPrice(data.vaoCarDetails.total.amount)}</p>
          </div>
        ) : null}
      </div>
      {isLoading ? (
        <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center min-h-[53px] backdrop-blur-sm">
          <Spinner />
        </div>
      ) : null}
    </div>
  );
};
